import { HeatIcon, SnowFlackIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

import { getSetpointLines } from "../helpers";
import { Card } from "./card";
import { SetpointLine } from "./setpoint-line";

interface AmbientRegulationProps {
  buildingId: string;
  airHandlerUnitId: string;
  temperature?: number;
  setpoint?: number;
  actualSetpoint?: number;
  coolingSetpoint?: number;
  coolingActualSetpoint?: number;
}

const AmbientRegulation: React.FC<AmbientRegulationProps> = ({
  buildingId,
  airHandlerUnitId,
  temperature,
  setpoint,
  actualSetpoint,
  coolingSetpoint,
  coolingActualSetpoint,
}) => {
  const heatingLines = getSetpointLines(actualSetpoint, setpoint);
  const coolingLines = getSetpointLines(coolingActualSetpoint, coolingSetpoint);
  // The couple needs its two quantity icons to be told apart; a lone temperature keeps the target.
  const couple = heatingLines.length > 0 && coolingLines.length > 0;

  return (
    <Card className="gap-1.25 flex w-fit flex-col items-start">
      <span className="font-medium">{m.air_handler_unit_ambient_regulation()}</span>
      {temperature !== undefined && (
        <span>{`${m.air_handler_unit_ambient_temperature()} : ${temperature.toFixed(1)} °C`}</span>
      )}
      {heatingLines.map(line => (
        <SetpointLine
          key={`heating-${line.kind}`}
          kind={line.kind}
          section="temperature"
          muted={line.muted}
          icon={couple ? HeatIcon : undefined}
          buildingId={buildingId}
          airHandlerUnitId={airHandlerUnitId}
        >
          {`${line.value.toFixed(1)} °C`}
        </SetpointLine>
      ))}
      {coolingLines.map(line => (
        <SetpointLine
          key={`cooling-${line.kind}`}
          kind={line.kind}
          section="temperature"
          muted={line.muted}
          icon={couple ? SnowFlackIcon : undefined}
          buildingId={buildingId}
          airHandlerUnitId={airHandlerUnitId}
        >
          {`${line.value.toFixed(1)} °C`}
        </SetpointLine>
      ))}
    </Card>
  );
};

AmbientRegulation.displayName = "AmbientRegulation";

export { AmbientRegulation };
export type { AmbientRegulationProps };
